import { createContextualCan } from '@casl/react';
import { createContext } from 'react';
import { defineAbilityFor } from './defineAbility';

type Context = ReturnType<typeof defineAbilityFor>;

//@ts-ignore
export const AbilityContext = createContext<Context>();
export const Can = createContextualCan(AbilityContext.Consumer);
